import ReturnsIcon from '@/components/ui/icons/ReturnsIcon';
// import BuyAgainIcon from '@/components/ui/icons/BuyAgainIcon';
import WishlistIcon from '@/components/ui/icons/WishlistIcon';
// import OffersPromotionsIcon from '@/components/ui/icons/OffersPromotionsIcon';
// import MyCopounsIcon from '@/components/ui/icons/MyCopounsIcon';
import ProfileIcon from '@/components/ui/icons/ProfileIcon';
import DeliveryAddressIcon from '@/components/ui/icons/DeliveryAddressIcon';
// import NotificationCenterIcon from '@/components/ui/icons/NotificationCenterIcon';
import ChangeLanguageIcon from '@/components/ui/icons/ChangeLanguageIcon';
// import PaymentMethodsIcon from '@/components/ui/icons/PaymentMethodsIcon';
// import PrescriptionUploadIcon from '@/components/ui/icons/PrescriptionUploadIcon';
// import MyPrescriptionsIcon from '@/components/ui/icons/MyPrescriptionsIcon';
// import ChatWithPharmacistIcon from '@/components/ui/icons/ChatWithPharmacistIcon';
// import FreeConsultationIcon from '@/components/ui/icons/FreeConsultationIcon';
import LoyaltyIcon from '@/components/ui/icons/LoyaltyIcon';
import WalletIcon from '@/components/ui/icons/WalletIcon';
import FAQsIcon from '@/components/ui/icons/FAQsIcon';
import PrivacyPolicyIcon from '@/components/ui/icons/PrivacyPolicyIcon';
import TermsConditionsIcon from '@/components/ui/icons/TermsConditionsIcon';
import WhatsAppChatIcon from '@/components/ui/icons/WhatsAppChatIcon';
import LogOutIcon from '@/components/ui/icons/LogOutIcon';
import DeleteAccountIcon from '@/components/ui/icons/DeleteAccountIcon';
import TrackOrderIcon from '@/components/ui/icons/track-order';
import DocumentIcon from '@/components/ui/icons/document';
import CustomerServiceIcon from '@/components/ui/icons/customer-service';
// import ReportProblemIcon from '@/components/ui/icons/report-problem';

const sidebarMenuData = {
  orderManagement: {
    header: 'Orders',
    data: [
      {
        title: 'Track Order',
        href: '/track-order',
        Icon: TrackOrderIcon,
      },
      {
        title: 'My Orders',
        href: '/user/orders',
        Icon: DocumentIcon,
        // requireAuth: true,
      },
      {
        title: 'Returns',
        href: '/user/returns',
        Icon: ReturnsIcon,
        // requireAuth: true,
      },
      // {
      //   title: 'Buy Again',
      //   href: '/buy-again',
      //   Icon: BuyAgainIcon,
      //   requireAuth: true,
      // },
      {
        title: 'Wishlist',
        href: '/favourite',
        Icon: WishlistIcon,
        // requireAuth: true,
      },
      // {
      //   title: 'Offers / Promotions',
      //   href: '/offers',
      //   Icon: OffersPromotionsIcon,
      //   requireAuth: true,
      // },
    ],
  },
  // userCopuns: [
  //   {
  //     title: 'My Copouns',
  //     href: '/my-copouns',
  //     Icon: MyCopounsIcon,
  //   },
  // ],
  userAccount: {
    header: 'Profile',
    data: [
      {
        title: 'My Profile',
        href: '/user',
        Icon: ProfileIcon,
        // requireAuth: true,
      },
      {
        title: 'Delivery Address',
        href: '/user/addresses',
        Icon: DeliveryAddressIcon,
        // requireAuth: true,
      },
      // {
      //   title: 'Notification Center',
      //   href: '/notification-center',
      //   Icon: NotificationCenterIcon,
      //   requireAuth: true,
      // },
      {
        title: 'Change Language',
        Icon: ChangeLanguageIcon,
        is_lang: true,
      },
      // {
      //   title: 'Payment Methods',
      //   href: '/payment-methods',
      //   Icon: PaymentMethodsIcon,
      //   requireAuth: true,
      // },
    ],
  },
  // prescriptions: [
  //   {
  //     title: 'Prescription Upload',
  //     href: '/prescription-upload',
  //     Icon: PrescriptionUploadIcon,
  //   },
  //   {
  //     title: 'My Prescriptions',
  //     href: '/my-prescriptions',
  //     Icon: MyPrescriptionsIcon,
  //   },
  //   {
  //     title: 'Chat with Pharmacist',
  //     href: '/chat-with-pharmacist',
  //     Icon: ChatWithPharmacistIcon,
  //   },
  //   {
  //     title: 'Free Consultation',
  //     href: '/free-consultation',
  //     Icon: FreeConsultationIcon,
  //   },
  // ],
  loyaltyAndWallet: {
    header: 'Services',
    data: [
      // {
      //   title: 'Loyalty',
      //   href: '/user/loyalty',
      //   Icon: LoyaltyIcon,
      //   requireAuth: true,
      // },
      {
        title: 'Wallet',
        href: '/user/wallet',
        Icon: WalletIcon,
        notShowTextValue: true,
        // requireAuth: true,
      },
      // {
      //   title: 'Coupons & Rewards',
      //   href: '/user/voucher',
      //   Icon: MyCopounsIcon,
      // },
      {
        title: 'Wallet',
        href: '/user/wallet',
        Icon: WalletIcon,
        bgColor: 'bg-[#f2fcf6]',
        subTitle: 'Use balance at checkout',
        // requireAuth: true,
      },
      {
        title: 'Points',
        href: '/user/loyalty',
        Icon: LoyaltyIcon,
        bgColor: 'bg-[#f2fcf6] rounded-b-[10px]',
        subTitle: 'Redeem points at checkout',

        // requireAuth: true,
      },
    ],
  },
  information: {
    header: 'Support',
    data: [
      {
        title: 'Support Center',
        href: '/contact-us',
        Icon: CustomerServiceIcon,
      },
      {
        title: 'FAQs',
        href: '/faqs',
        Icon: FAQsIcon,
      },
      {
        title: 'Privacy',
        href: '/privacy-policy',
        Icon: PrivacyPolicyIcon,
      },
      {
        title: 'Terms & Conditions',
        href: '/terms-and-conditions',
        Icon: TermsConditionsIcon,
      },
      {
        title: 'WhatsApp Chat',
        href: 'https://wa.me/+966920008391',
        target: '_blank',
        Icon: WhatsAppChatIcon,
      },
    ],
  },
  // support: [
  //   {
  //     title: 'WhatsApp Chat',
  //     href: '/whatsapp-chat',
  //     Icon: WhatsAppChatIcon,
  //   },
  //   {
  //     title: 'Customer Service',
  //     href: '/customer-service',
  //     Icon: CustomerServiceIcon,
  //   },
  //   {
  //     title: 'Report a Problem',
  //     href: '/report-a-problem',
  //     Icon: ReportProblemIcon,
  //   },
  // ],
  accountManagement: {
    header: 'Account Actions',
    data: [
      {
        title: 'Log Out',
        href: '',
        Icon: LogOutIcon,
        requireAuth: true,
      },
      {
        title: 'Delete Account',
        href: '/delete-account',
        Icon: DeleteAccountIcon,
        requireAuth: true,
      },
    ],
  },
};

export default sidebarMenuData;
